import { PixelRatioImage, type PixelRatioImageProps } from "@/components/common/pixel-ratio-image";
import articleImage from "@/assets/agent-user-detail/article@3x.webp";

export const ArticleImage = (props: Omit<PixelRatioImageProps, "images">) => {
  return (
    <PixelRatioImage
      images={[articleImage]}
      {...props}
    />
  );
};

ArticleImage.displayName = 'ArticleImage';
